<template>
    <div v-if="mostrar" class="modal-overlay">
      <div class="modal-container">
        <!-- Cabeçalho -->
        <div class="modal-header">
          <h6>Cancelar Supervisão</h6>
          <i class="bi bi-x-circle close-icon" @click="fechar" />
        </div>
  
        <!-- Conteúdo -->
        <div class="modal-content">
            <ul class="list-unstyled mb-3">
                <li><strong>Solicitada por:</strong> {{ supervisao.instrutor }}</li>
                <li><strong>Turma:</strong> {{ supervisao.turma }}</li>
            </ul>
            <p><strong>Realizada por:</strong> {{ supervisao.por === null ? userName : supervisao.por }}</p>
            <!-- Campo Aluno -->
            <div class="row mb-2">
            <div class="col">
              <label>Aluno</label>
              <input
                type="text"
                :value="supervisao.aluno"
                class="form-control"
                disabled
              />
            </div>
          </div>

          <!-- Campo Observações -->
          <div class="form-group mb-2">
            <label for="obs">
              Motivo do cancelamento
              <span v-if="!modoVisualizacao" class="required">*</span>
            </label>
            <textarea
              id="obs"
              v-model="form.observacoes"
              class="form-control"
              rows="6"
              :style="{ height: modoVisualizacao ? '200px' : '100px' }"
              :disabled="modoVisualizacao"
              required
            ></textarea>
          </div>
        </div>
  
        <!-- Botões -->
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="fechar">
            {{ modoVisualizacao ? 'Fechar' : 'Cancelar' }}
          </button>
          <template v-if="!modoVisualizacao">
            <button
              class="btn btn-danger"
              :disabled="!form.observacoes || isSubmitting"
              @click="confirmarCancelamento"
            >
              {{ isSubmitting ? 'Processando…' : 'Confirmar' }}
            </button>
          </template>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, watch, getCurrentInstance } from 'vue';
  import axios from '@/services/axios';
  
  const props = defineProps({
    mostrar: { type: Boolean, default: false },
    supervisao: { type: Object, required: true },
    modoVisualizacao: { type: Boolean, default: false }
  });
  const emit = defineEmits(['close', 'cancelado']);
  
  const form = ref({ observacoes: '' });
  const isSubmitting = ref(false);
  const instance = getCurrentInstance();
  const gs = instance.appContext.config.globalProperties.$globalState;
  const userName = gs.userName;
  
  watch(
    () => props.mostrar,
    async visible => {
      if (!visible) return;
      // sempre limpar antes
      form.value.observacoes = '';
  
      // se já estiver em modo visualização (cancelada) ou receber o flag
      if (props.supervisao.cancelada || props.modoVisualizacao) {
        try {
          const res = await axios.get(
            `/operacional/supervisoes/${props.supervisao.id}`
          );
          form.value.observacoes = res.data.data.observacoes || '';
        } catch (err) {
          console.error('❌ Erro ao carregar motivo do cancelamento:', err);
        }
      }
    },
    { immediate: true }
  );
  
  function fechar() {
    emit('close');
  }
  
  async function confirmarCancelamento() {
    if (isSubmitting.value) return;
    isSubmitting.value = true;
  
    const hoje = new Date().toISOString().split('T')[0];
  
    try {
      await axios.patch(
        `/operacional/supervisoes/${props.supervisao.id}`,
        {
          observacoes: form.value.observacoes,
          cancelada: true,
          por: userName,
          data_realizacao: hoje
        }
      );
      emit('cancelado');
      fechar();
    } catch (err) {
      console.error('Erro ao cancelar supervisão:', err);
    } finally {
      isSubmitting.value = false;
    }
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }
  .modal-container {
    background: #fff;
    width: 100%;
    max-width: 500px;
  }
  .modal-header {
    background: #ccc;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .close-icon {
    font-size: 1.5rem;
    cursor: pointer;
  }
  .modal-content {
    padding: 15px;
  }
  .modal-footer {
    padding: 10px 15px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .required {
    color: red;
  }
  .btn {
    min-width: 70px;
    padding: 6px 15px;
    font-size: 14px;
    cursor: pointer;
    border: none;
  }
  .btn-danger {
    background-color: #dc3545;
    color: #fff;
  }
  </style>
  